var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTeamworkIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 84.272 62",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".teamwork_icon_svg__a,.teamwork_icon_svg__b{fill:none;stroke:inherit;stroke-width:2px}.teamwork_icon_svg__a{stroke-linecap:round;stroke-linejoin:round;fill-rule:evenodd}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-svg-primary": "stroke"
  }, /*#__PURE__*/React.createElement("path", {
    className: "teamwork_icon_svg__a",
    d: "M51.859 37.46v17.1a3.672 3.672 0 003.672 3.681 3.672 3.672 0 003.672-3.672l-.079-17.111a13.818 13.818 0 00-13.785-13.807h-6.47a13.818 13.818 0 00-13.8 13.809v17.1a3.672 3.672 0 003.67 3.684 3.672 3.672 0 003.672-3.672V37.46M50.318 9.181c0 4.518-3.664 10.691-8.181 10.691s-8.182-6.164-8.182-10.691a8.181 8.181 0 1116.363 0zM76.536 41.934v15.7a3.364 3.364 0 003.364 3.364 3.364 3.364 0 003.373-3.364v-15.7a12.673 12.673 0 00-12.7-12.682H64.62a12.816 12.816 0 00-3.365.449M75.117 15.971c0 4.148-3.364 9.819-7.512 9.819s-7.512-5.68-7.512-9.819a7.512 7.512 0 1115.024 0zM7.746 41.934v15.7a3.373 3.373 0 01-3.373 3.364A3.364 3.364 0 011 57.636l.044-15.7a12.682 12.682 0 0112.682-12.684h5.927a12.77 12.77 0 013.364.449M9.155 15.971c0 4.148 3.364 9.819 7.512 9.819s7.512-5.68 7.512-9.819a7.512 7.512 0 10-15.024 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "teamwork_icon_svg__b",
    d: "M26.757 58.5h-19M76.757 58.5h-19M52.757 56.5h-21"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTeamworkIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/teamwork_icon.59a777086821cc89fb8f90b8c842f42c.svg";